import React, { useState } from "react";
import { Form, Input, Button, Card, Select, DatePicker, message } from "antd";
import { useNavigate } from "react-router-dom";
import { apiService } from "@/services/api";

const { TextArea } = Input;

export const NotificationCreate: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState<string>("DRAFT");
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      const payload = {
        title: values.title,
        type: values.type,
        content: values.content,
        audience: values.audience,
        status: values.status,
        scheduledDate: values.scheduledDate?.toISOString(),
      };
      await apiService.createNotification(payload);
      message.success("Notification créée avec succès");
      navigate("/notifications");
    } catch (e: any) {
      message.error("Erreur lors de la création de la notification");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card title="Créer une notification">
      <Form layout="vertical" onFinish={onFinish} style={{ maxWidth: 600 }}>
        <Form.Item
          label="Titre"
          name="title"
          rules={[{ required: true, message: "Le titre est requis" }]}
        >
          <Input placeholder="Titre de la notification" maxLength={255} />
        </Form.Item>

        <Form.Item
          label="Type"
          name="type"
          rules={[{ required: true, message: "Le type est requis" }]}
        >
          <Select placeholder="Sélectionner un type">
            <Select.Option value="PUSH">Push</Select.Option>
            <Select.Option value="EMAIL">Email</Select.Option>
            <Select.Option value="SMS">SMS</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Message"
          name="content"
          rules={[{ required: true, message: "Le message est requis" }]}
        >
          <TextArea rows={4} placeholder="Contenu de la notification" maxLength={2000} />
        </Form.Item>

        <Form.Item
          label="Audience"
          name="audience"
          rules={[{ required: true, message: "L'audience est requise" }]}
        >
          <Select placeholder="Sélectionner l'audience cible">
            <Select.Option value="ALL">Tous les utilisateurs</Select.Option>
            <Select.Option value="PREMIUM">Utilisateurs Premium</Select.Option>
            <Select.Option value="FREE">Utilisateurs gratuits</Select.Option>
            <Select.Option value="NEW">Nouveaux utilisateurs</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Statut"
          name="status"
          initialValue="DRAFT"
          rules={[{ required: true }]}
        >
          <Select onChange={setStatus}>
            <Select.Option value="DRAFT">Brouillon</Select.Option>
            <Select.Option value="SCHEDULED">Programmée</Select.Option>
          </Select>
        </Form.Item>

        {status === "SCHEDULED" && (
          <Form.Item
            label="Date d'envoi"
            name="scheduledDate"
            rules={[{ required: true, message: "La date est requise pour une notification programmée" }]}
          >
            <DatePicker
              showTime
              style={{ width: "100%" }}
              placeholder="Sélectionner date et heure"
            />
          </Form.Item>
        )}

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Créer la notification
          </Button>
          <Button style={{ marginLeft: 8 }} onClick={() => navigate("/notifications")}>
            Annuler
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default NotificationCreate;
